module.exports = __webpack_public_path__ + "images/psa9171d5c24c090a43875caf42f9db2447.png";